import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import jwtDecode from 'jwt-decode';

import Sotyktu_PassHeader from '../shared/assets/sotyktu_header.svg';
import Zeposia_PassHeader from '../shared/assets/zeposia_header.svg';
import Camzyos_PassHeader from '../shared/assets/camzyos_header.svg';

import Sotyktu_iosPass from '../shared/assets/pass_images/sotyktu_ios_pass_mobile.png';
import Sotyktu_androidPass from '../shared/assets/pass_images/sotyktu_android_pass.png';

import Zeposia_iosPass from '../shared/assets/pass_images/zeposia_ios_pass_mobile.png';
import Zeposia_androidPass from '../shared/assets/pass_images/zeposia_android_pass.png';

import Camzyos_iosPass from '../shared/assets/pass_images/camzyos_ios_pass_mobile.svg';
import Camzyos_androidPass from '../shared/assets/pass_images/camzyos_android_pass.svg';

import analyticsService from '../utils/analytics';

const useStyles = makeStyles(() => ({
    successRoot: {
        gap: '10px',
        margin: '0px 20px'
    },
    sotyktu_header1: {
        fontWeight: '600 !important',
        color: '#4933DA',
        lineHeight: '1.35 !important'
    },
    zeposia_header1: {
        fontWeight: '600 !important',
        color: '#0054A6',
        lineHeight: '1.35 !important'
    },
    passAlert: {
        width: "150px",
        height: "150px",
        display: "flex",
        margin: "auto"
    },
    sotyktu_error_details: {
        lineHeight: 1.5
    },
    cardImage: {
        maxWidth: '350px',
        width: '85%',
        borderRadius: '8px',
        boxShadow: '0 3px 10px rgb(0 0 0 / 20%)'
    },
    cardImg: {
        maxWidth: '350px',
        width: '85%',
    }
}));

const Success = (props) => {
    const classes = useStyles();
    const [pass, setPass] = useState();

    useEffect(() => {
        let digitalData = analyticsService.getDigitalData();
        digitalData['page_name'] = "Pass success page";
        analyticsService.setDigitalData(digitalData);

        const queryParams = new URLSearchParams(window.location.search);
        const queryToken = queryParams.get("data");
        if (queryToken) {
            try {
                const decodedToken = jwtDecode(queryToken);
                setPass(decodedToken.product);
            } catch (err) {
                // navigate(`/error`, { state: { error_type: 'invalid_token' } });
            }
        }
    }, [])

    const togglePageContent = () => {
        switch (pass) {
            case 'Sotyktu':
                return <div className={classes.successRoot}>
                    <img style={{ height: '125px' }} src={Sotyktu_PassHeader} />
                    <hr
                        style={{
                            border: 0,
                            height: '7px',
                            background: 'linear-gradient(to right, #4933DA 0% ,#4933DA 50%, #D3019F 50%,#D3019F 75%, #96FF73 75% )',
                        }}
                    ></hr>
                    <br />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                        <Typography variant='h6' className={classes.sotyktu_header1}>
                            Your Co-Pay card has been added to your wallet!
                        </Typography>
                        <Typography variant='body' className={classes.sotyktu_error_details}>
                            Please access your wallet in order to view it.
                        </Typography>
                        <div style={{ position: 'relative' }}>
                            <img
                                className={classes.cardImage}
                                src={props.platform === 'iphone' ? Sotyktu_iosPass : Sotyktu_androidPass}
                                alt="card"
                            />
                        </div >
                    </div >
                </div>
            case 'Zeposia':
                return <div className={classes.successRoot}>
                    <img style={{ height: '125px', width: '100%' }} src={Zeposia_PassHeader} />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <Typography variant='h6' className={classes.zeposia_header1}>
                            Your Co-pay card has been added to your wallet!
                        </Typography>
                        <Typography variant='body' className={classes.sotyktu_error_details}>
                            Please access your wallet in order to view it.
                        </Typography>
                        <div style={{ position: 'relative' }}>
                            <img
                                className={props.platform === 'iphone' ? classes.cardImage : classes.cardImg}
                                src={props.platform === 'iphone' ? Zeposia_iosPass : Zeposia_androidPass}
                                alt="card"
                            />
                        </div >
                    </div >
                </div>
            case 'Camzyos':
                return <div className={classes.successRoot}>
                    <img style={{ height: '125px', width: '100%' }} src={Camzyos_PassHeader} />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

                        <Typography variant='h6' className={classes.zeposia_header1}>
                            Your Co-pay program has been added to your wallet!
                        </Typography>
                        <Typography variant='body' className={classes.sotyktu_error_details}>
                            Please access your wallet in order to view it.
                        </Typography>
                        <div style={{ position: 'relative' }}>
                            <img
                                className={props.platform === 'iphone' ? classes.cardImage : classes.cardImg}
                                src={props.platform === 'iphone' ? Camzyos_iosPass : Camzyos_androidPass}
                                alt="card"
                            />
                        </div >
                    </div >
                </div>
            default: break;

        }
    }

    return (
        <>
            {togglePageContent()}
        </>
    )
}

export default Success